// extracted by mini-css-extract-plugin
export default {"inicioContainer":"Dashboard_inicioContainer__d0wro","cards":"Dashboard_cards__Vqq3t"};